import { Grid, TextField } from "@mui/material"
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers"
import { toDate } from "../../../services/time/TimeService"


type Props = {
    startDateValue: number,
    endDateValue: number,
    startDateChange: (date: number) => void,
    endDateChange: (date: number) => void,
    timePicker: boolean
}
export const DateRangePicker: React.FC<Props> = ({ startDateChange, endDateChange, startDateValue, endDateValue, timePicker = false }) => {

    const picker = timePicker ?
        (
            <>
                <Grid item xs={12} md={6} justifyContent="center" display="flex">
                    <DateTimePicker
                        label="Data rozpoczęcia"
                        value={toDate(startDateValue)}
                        inputFormat="dd.MM.yyyy HH:mm"
                        onChange={(date) => {
                            if (date) startDateChange(date)
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />

                </Grid>
                <Grid item xs={12} md={6} justifyContent="center" display="flex">
                    <DateTimePicker
                        label="Data zakończenia"
                        value={toDate(endDateValue)}
                        inputFormat="dd.MM.yyyy HH:mm"
                        onChange={(date) => {
                            if (date) endDateChange(date)
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </Grid>
            </>
        )
        : (<>
            <Grid item xs={12} md={6} justifyContent="center" display="flex">
                <DatePicker
                    label="Data rozpoczęcia"
                    value={toDate(startDateValue)}
                    inputFormat="dd.MM.yyyy"
                    onChange={(date) => {
                        if (date) startDateChange(date.startOf('day'))
                    }}
                    renderInput={(params) => <TextField {...params} />}
                />
            </Grid><Grid item xs={12} md={6} justifyContent="center" display="flex">
                <DatePicker
                    label="Data zakończenia"
                    value={toDate(endDateValue)}
                    inputFormat="dd.MM.yyyy"
                    onChange={(date) => {
                        if (date) endDateChange(date.endOf('day'))
                    }}
                    renderInput={(params) => <TextField {...params} />}
                />
            </Grid>
        </>)
    return (
        <Grid container justifyContent="center" alignItems="center" sx={{
            '& .MuiTextField-root': { m: 2, width: 300 },
        }}>
            {picker}
        </Grid>
    )
}
